/**
 * Reasoning catalog shared by every admin review flow (application flags,
 * payments, providers and provider items). The numeric value is what the API
 * stores, the label is what the reviewer sees.
 */
export const REASONING_LABELS = [
  'No selection',
  'Based on evidence',
  'Based on program rules',
  'Other',
] as const

export type ReasoningLabel = (typeof REASONING_LABELS)[number]

export const REASONING_VALUES = {
  'No selection': 0,
  'Based on evidence': 1,
  'Based on program rules': 2,
  Other: 3,
} as const satisfies Record<ReasoningLabel, number>

/**
 * Options offered in the reasoning picker. `No selection` is the API default
 * for records that were never reviewed, not something a reviewer can choose.
 */
export const SELECTABLE_REASONINGS = REASONING_LABELS.filter(
  (label) => label !== 'No selection'
)
